import * as yup from "yup";

export const digitalKeysUpdateSchema = yup.object().shape({
  keys: yup.array().of(
    yup.object().shape({
      id: yup.number().required(),
      key: yup
        .string()
        .required("Key is required")
        .test("pending-check", 'Key cannot be "Pending"', function (value) {
          // Add your custom condition here
          return value !== "Pending";
        }),
    })
  ),
});

export const poNumberUpdateSchema = yup.object().shape({
  poNumber: yup.string().default("").required("Key is required"),
});

export const updateQuoteProductExpiryDateSchema = yup.object().shape({
  expiryDate: yup.string().required().default("").label("Expiry date"),
});

export const addQuoteSchema = yup.object().shape({
  contactName: yup.string().required().label("Contact name"),
  contactPhone: yup.string().required().label("Contact phone"),
  deliveryAddress: yup.string().required().label("Delivery address"),
  sameAsDelivery: yup.bool(),
  isExpressShipping: yup.bool(),
  state: yup.number().required("State"),
  companyId: yup.number().required().label("Company"),
  resellerId: yup.number().required().label("Reseller"),
  billingAddress: yup
    .string()
    .when(["sameAsDelivery"], {
      is: (sameAsDelivery) => sameAsDelivery === true,
      then: () => yup.string().notRequired(),
      otherwise: () => yup.string().required("Billing address"),
    })
    .label("Billing address"),
  products: yup.array().of(
    yup.object().shape({
      product: yup.number().nullable().default(null),

      type: yup.string().when("product", {
        is: (product) => product === null,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required("Type is required"),
      }),

      variation: yup.number().when(["type", "product"], {
        is: (type, product) => product !== null && type !== "simple",
        then: (schema) => schema.required("Variation is required").min(0).integer(),
        otherwise: (schema) => schema.notRequired(),
      }),

      attributes: yup.array().of(yup.string()).notRequired(),

      qty: yup.number().required("Quantity is required").min(1),

      name: yup.string().when("product", {
        is: (product) => product === null || product === "",
        then: (schema) => schema.required("Name is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      is_digital_good: yup
        .bool()
        .when("product", {
          is: (product) => product === null || product === "",
          then: (schema) => schema.required("Type is required"),
          otherwise: (schema) => schema.notRequired(),
        })
        .default(false),

      price: yup.number().when("product", {
        is: (product) => product === null || product === "",
        then: (schema) => schema.required("Price is required").min(1),
        otherwise: (schema) => schema.notRequired(),
      }),

      sku: yup.string().when("product", {
        is: (product) => product === null || product === "",
        then: (schema) => schema.required("SKU is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    })
  ),
});

export const convertToOrderSchema = yup.object().shape({
  paymentMethod: yup.string().required("Payment method is required"),
  paymentStatus: yup.string().required("Payment status is required"),
});
